<template>
  <el-row class="access full-height" :gutter="48" v-loading="contentLoading">
    <el-col class="access-main" :span="19">
      <!-- start: steps -->
      <el-steps class="steps" finish-status="success" align-center :active="activeContentStep">
        <el-step v-for="step in logSteps" :key="step.name" :title="step.label"></el-step>
      </el-steps>
      <!-- end: steps -->

      <!-- start: step 0 -->
      <div class="log-step" v-if="activeStep === 0">
        <access-main-creator
          ref="accessMainCreator"
          :datasource="datasource"
          :pageType="pageType"
          @getLogDetail="handleGetLogDetail"
          @getProjectDetail="handleGetProjectDetail"
        ></access-main-creator>
      </div>
      <!-- end: step 0 -->

      <!-- start: step 1 -->
      <access-config-creator
        class="log-step access-config"
        v-if="activeStep === 1"
        ref="accessConfigCreator"
        v-loading="accessConfigLoading"
      ></access-config-creator>
      <!-- end: step 1 -->

      <!-- start: step 2 -->
      <div class="log-analyze log-step" v-if="logSteps[activeStep].name === 'config'">
        <analyze-table-viewer
          class="log-analyze-content"
          :datasource="datasource"
          ref="analyzeTableViewer"
          @loading="onShowLoading"
        ></analyze-table-viewer>
      </div>
      <!-- end: step 2 -->

      <!-- start: step 3 -->
      <div class="log-description log-step" v-if="logSteps[activeStep].name === 'guide'">
        <log-access-guide-viewer
          v-if="datasource.dataSourceConfigData"
          ref="logAccessGuideViewer"
          :dataSourceConfigData="datasource.dataSourceConfigData"
        ></log-access-guide-viewer>
      </div>
      <!-- end: step 3 -->

      <!-- start: step 4 -->
      <div class="log-end log-step" v-if="activeStep === logSteps.length - 1">
        <h3 class="log-end-title">
          <i class="el-icon-circle-check-outline"></i>
          恭喜您完成数据接入配置，点击下方链接可查询日志
        </h3>
        <div class="log-end-content" @click="onLogDetail">
          <div class="log-end-content-icon">
            <i class="el-icon-document"></i>
          </div>
          <div class="log-end-content-text">
            <h4 class="log-end-content-text-title">查询日志</h4>
            <div ref="logDescription" class="log-end-content-text-description">
              点击这里查询日志
            </div>
          </div>
        </div>
      </div>
      <!-- end: step 4 -->

      <!-- start: buttons -->
      <el-col class="buttons" :span="24">
        <el-button size="small" v-if="activeStep === 0" @click="onCancelAccess">取消</el-button>
        <el-button
          size="small"
          v-if="activeStep > 0 && activeStep < logSteps.length - 2"
          @click="goBackStep"
          >上一步</el-button
        >
        <el-button type="primary" v-if="activeStep < logSteps.length - 1" @click="goNextStep"
          >下一步</el-button
        >
        <el-button type="primary" v-if="activeStep === logSteps.length - 1" @click="onLogSuccess"
          >完成</el-button
        >
      </el-col>
      <!-- end: buttons -->
    </el-col>

    <el-col class="access-aside" :span="5">
      <div class="info">
        <div class="info-line">
          <div class="info-line-label">日志类型：</div>
          <div class="info-line-value">{{ datasource.datasourceName }}</div>
        </div>
        <div class="info-line">
          <div class="info-line-label">项目：</div>
          <div class="info-line-value word-break">{{ projectDetail.name }}</div>
        </div>
        <div class="info-line">
          <div class="info-line-label word-break">日志库：</div>
          <div class="info-line-value">{{ logDetail.name }}</div>
        </div>
        <div class="info-line">
          <div class="info-line-label">区域：</div>
          <div class="info-line-value">{{ projectDetail.regionId }}</div>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { reqCreateRule } from '@/api/log';
import { reqCreateConfig } from '@/api/config';
import { reqShowDatasourceConfig } from '@/api/datasource';
import AccessConfigCreator from '../common/access-rule/AccessConfigCreator';
import AnalyzeTableViewer from './AnalyzeTableViewer';
import AccessMainCreator from './AccessMainCreator';
import LogAccessGuideViewer from '../common/LogAccessGuideViewer';

export default {
  name: 'Access',

  components: {
    AccessConfigCreator,
    AnalyzeTableViewer,
    AccessMainCreator,
    LogAccessGuideViewer
  },

  data() {
    return {
      pageType: '',
      activeStep: 0,
      activeContentStep: 0,
      contentLoading: false,
      steps: [
        {
          label: '选择日志空间',
          name: 'space'
        },
        {
          label: '日志规则配置',
          name: 'rule'
        },
        {
          label: '查询分析配置',
          name: 'config'
        },
        {
          label: '日志接入指南',
          name: 'guide'
        },
        {
          label: '结束',
          name: 'end'
        }
      ],
      datasource: {
        datasourceName: '',
        dataSourceId: null,
        dataSourceConfigData: ''
      },
      projectDetail: {
        name: '',
        gmtCreate: '',
        regionId: '',
        description: ''
      },
      logDetail: {
        name: '',
        gmtCreate: '',
        description: ''
      },
      analyzeData: '',
      accessConfigData: sessionStorage.getItem('accessConfigData')
        ? JSON.parse(sessionStorage.getItem('accessConfigData'))
        : {},
      accessConfigLoading: false,
      stepRelation: {
        simple: ['space', 'rule', 'guide', 'end']
      },
      logAnalysisConfigCustomDtoList: [],
      logSteps: []
    };
  },

  async created() {
    if (this.$route.name === 'ProjectsAccess') {
      this.pageType = 'NO_PROJECT';
    } else if (this.$route.name === 'ProjectsDetailAccess') {
      this.pageType = 'WITH_PROJECT';
      this.projectDetail.id = this.$route.params.projectId;
    } else {
      this.$message.error('页面跳转异常');
      this.$router.replace({ name: 'Index' });
    }

    if (sessionStorage.getItem('logData')) {
      const logData = JSON.parse(sessionStorage.getItem('logData'));
      this.logDetail.storeDbName = logData.storeDbName;
      this.logDetail.name = logData.name;
      this.logDetail.id = logData.id;
    }

    if (sessionStorage.getItem('projectData')) {
      const projectData = JSON.parse(sessionStorage.getItem('projectData'));
      this.projectDetail.id = projectData.id;
      this.projectDetail.name = projectData.name;
      this.projectDetail.regionId = projectData.regionId;
    }

    this.getDataSourceDetail();

    // 刷新页面保存进度条
    if (sessionStorage.getItem('step')) {
      this.activeStep = JSON.parse(sessionStorage.getItem('step')).activeStep;
      this.activeContentStep = JSON.parse(sessionStorage.getItem('step')).activeContentStep;

      if (this.logSteps[this.activeStep].name === 'guide') {
        this.getDataSourceConfig();
      }
    }
  },

  /**
   * 退出前清空本地数据
   */
  beforeDestroy() {
    sessionStorage.removeItem('logType');
    sessionStorage.removeItem('step');
    sessionStorage.removeItem('projectData');
    sessionStorage.removeItem('logData');
    sessionStorage.removeItem('accessConfigData');
    sessionStorage.removeItem('analyzeData');
    sessionStorage.removeItem('commonAnalyzeData');

    // 规则配置解析出来的 key
    sessionStorage.removeItem('analyzeKeys');
  },

  methods: {
    onGetLogSteps() {
      try {
        this.logSteps = this.steps.filter(step => {
          return this.stepRelation[this.datasource.name.toLowerCase()].indexOf(step.name) > -1;
        });
      } catch (e) {
        this.logSteps = this.steps;
      }
    },
    /**
     * 数据分析配置添加 loading
     */
    onShowLoading(onOff) {
      this.contentLoading = onOff;
    },
    /**
     * 取消接入数据
     */
    onCancelAccess() {
      if (this.$route.name === 'ProjectsAccess') {
        this.$router.push({ name: 'ProjectsIndex' });
      } else if (this.$route.name === 'ProjectsDetailAccess') {
        this.$router.push({ name: 'ProjectsDetail', params: { ...this.$route.params } });
      }
    },
    /**
     * 获取 datasource 详情
     */
    getDataSourceDetail() {
      try {
        const datasource = JSON.parse(sessionStorage.getItem('logType'));
        this.datasource.datasourceName = datasource.displayName;
        this.datasource.dataSourceId = datasource.id;
        this.datasource.name = datasource.name;
        this.onGetLogSteps();
      } catch (e) {
        // 如果没取到本地数据，提示错误
        this.$message.error('网络连接超时，请重新选择日志类型');
      }
    },
    /**
     * 获取日志详情
     */
    handleGetLogDetail(logDetail) {
      this.logDetail = logDetail;
    },
    /**
     * 获取项目详情
     */
    handleGetProjectDetail(projectDetail) {
      this.projectDetail = projectDetail;
    },
    /**
     * 获取配置数据
     */
    async getDataSourceConfig() {
      try {
        this.contentLoading = true;
        const { data } = await reqShowDatasourceConfig({
          dataSourceId: this.datasource.dataSourceId,
          dataSourceName: this.datasource.name,
          projectId: this.projectDetail.id,
          logId: this.logDetail.id,
          logStoreDbName: this.logDetail.storeDbName,
          logPath: this.accessConfigData.logPath,
          parseRuleId: this.accessConfigData.id
        });

        if (data) {
          this.datasource.dataSourceConfigData = data;
        }
      } finally {
        this.contentLoading = false;
      }
    },
    /**
     * 上一步
     */
    goBackStep() {
      this.activeStep--;
      this.activeContentStep--;

      // 保存步骤条进度
      sessionStorage.setItem(
        'step',
        JSON.stringify({
          activeStep: this.activeStep,
          activeContentStep: this.activeContentStep
        })
      );
    },
    /**
     * 下一步
     */
    async goNextStep() {
      if (this.activeStep === 0) {
        try {
          await this.$refs.accessMainCreator.onSubmit();
          sessionStorage.setItem('logData', JSON.stringify(this.logDetail));
          sessionStorage.setItem('projectData', JSON.stringify(this.projectDetail));
        } catch {
          return;
        }
      }

      if (this.activeStep === 1) {
        try {
          this.accessConfigLoading = true;
          await this.$refs.accessConfigCreator.onSubmit();

          this.accessConfigData = this.$refs.accessConfigCreator.onSaveData();

          const metrics = {
            file_encoding: 'utf8',
            log_path: this.accessConfigData.logPath,
            version: 1,
            data_source_id: this.datasource.dataSourceId,
            project_id: this.projectDetail.id,
            log_id: this.logDetail.id,
            data_source_name: this.datasource.name,
            log_sample: this.accessConfigData.logExample,
            regex_value: this.accessConfigData.pattern,
            log_format: this.accessConfigData.logFormat,
            delimiter_separator: this.accessConfigData.delimiterSeparator,
            customize: this.accessConfigData.customize
          };

          if (
            this.accessConfigData.results &&
            this.accessConfigData.results.length > 0 &&
            this.accessConfigData.results[0].key
          ) {
            metrics.column_keys = this.accessConfigData.results.map(item => item.key);
            metrics.column_keys_values = this.accessConfigData.results;
          }

          // 有 id 表示已经保存过
          if (this.accessConfigData.id) {
            metrics.id = this.accessConfigData.id;
          }

          try {
            this.contentLoading = true;
            const params = {
              name: this.accessConfigData.name,
              metrics: JSON.stringify(metrics),
              id: this.accessConfigData.id,
              logId: this.logDetail.id
            };

            if (this.accessConfigData.id) {
              params.id = this.accessConfigData.id;
            }

            const { data } = await reqCreateRule(params);

            this.accessConfigData.id = data.id;

            sessionStorage.setItem('analyzeKeys', data.metrics);

            sessionStorage.setItem('accessConfigData', JSON.stringify(this.accessConfigData));
          } finally {
            this.contentLoading = false;
          }
          // 加载 Filebeat 配置
          this.getDataSourceConfig();
        } catch {
          return;
        } finally {
          this.accessConfigLoading = false;
        }
      }

      if (this.logSteps[this.activeStep].name === 'config') {
        this.analyzeData = this.$refs.analyzeTableViewer.onSaveData();
        // 如果没有添加指定字段查询表格，给出提示
        if (this.analyzeData && this.analyzeData.length < 1) {
          try {
            await this.$msgbox({
              title: `警告`,
              message: `您还没有指定字段，是否继续？`,
              type: 'warning',
              showCancelButton: true,
              beforeClose: async (action, instance, done) => {
                if (action === 'cancel') {
                  done();
                  return;
                }
                done();
              }
            });
          } catch (e) {
            if (e === 'cancel') return;
          }
        }

        try {
          this.contentLoading = true;
          // 只传此次新增的数据
          const filterAnalyzeData = this.analyzeData.filter(item => {
            return !item.id;
          });

          this.logAnalysisConfigCustomDtoList = [];

          for (let item of filterAnalyzeData) {
            const tempData = {
              alias: item.alias,
              fieldName: item.fieldName,
              fieldType: item.fieldType,
              logId: this.logDetail.id,
              openStatistics: item.openStatistics
            };

            if (item.analysisConfigDtoList && item.analysisConfigDtoList.length > 0) {
              tempData.analysisConfigDtoList = item.analysisConfigDtoList;
            }

            if (item.fieldType === 'json') {
              tempData.alias = '';
              tempData.openStatistics = false;

              if (item.analysisConfigDtoList.length < 1) {
                this.$message.warning('json 类型必须包含子字段');
                return;
              }
            }

            this.logAnalysisConfigCustomDtoList.push(tempData);
          }
        } catch {
          return;
        } finally {
          this.contentLoading = false;
        }
      }

      if (this.activeStep === this.logSteps.length - 3) {
        const configData = {
          logDataSourceCustomDto: {
            dataSourceId: this.datasource.dataSourceId,
            logId: this.logDetail.id,
            projectId: this.projectDetail.id,
            logParseRuleId: this.accessConfigData.id
          },
          logAnalysisConfigCustomDtoList: this.logAnalysisConfigCustomDtoList
        };

        await reqCreateConfig(configData);
      }

      if (this.activeStep === this.logSteps.length - 2) {
        // 最后一步是完成状态，也就是步骤条比内容快一步，所以这里多加一次
        this.activeContentStep++;
      }

      this.activeStep++;
      this.activeContentStep++;
      sessionStorage.setItem(
        'step',
        JSON.stringify({
          activeStep: this.activeStep,
          activeContentStep: this.activeContentStep
        })
      );
    },
    /**
     * 跳转到项目详情
     */
    onLogDetail() {
      sessionStorage.setItem('logInfo', JSON.stringify(this.logDetail));
      this.$router.push({
        name: 'ProjectsDetail',
        params: { projectId: this.projectDetail.id }
      });
    },
    /**
     * 点击完成和取消操作相同
     */
    onLogSuccess() {
      this.onCancelAccess();
    }
  }
};
</script>

<style lang="scss" scoped>
$margin-large: 74px;

h3,
h4 {
  margin: 0;
}
p {
  margin: 0;
}
.access {
  padding: 0 20px;

  /deep/ .steps {
    margin-top: 20px;
    .el-step__title.is-success {
      color: #00a0ff;
    }

    .el-step__head.is-success {
      color: #00a0ff;
      border-color: #00a0ff;
    }
  }

  &-main {
    display: flex;
    flex-direction: column;
    height: 100%;

    .buttons {
      flex: 1;
      margin-bottom: 30px;
      text-align: center;
    }

    /deep/ .el-form-item:not(.form-tip-top) {
      margin-bottom: 30px !important;
    }
  }

  &-aside {
    position: relative;
    height: 100%;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 20px;
      bottom: 30px;
      display: inline-block;
      width: 1px;
      background: #f1f1f1;
    }

    .info {
      display: table;
      width: 100%;
      font-size: 12px;

      &-line {
        display: table-row;
        height: 48px;

        &-label {
          display: table-cell;
          width: 40%;
          vertical-align: middle;
          text-align: right;
        }

        &-value {
          display: table-cell;
          padding-left: 18px;
          vertical-align: middle;
          text-align: left;
        }
      }
    }
  }

  &-config {
    display: flex;
    justify-content: center;
  }

  .log-step {
    overflow: auto;
    margin: 9px 0 30px;
    font-size: 12px;

    &-tip {
      cursor: pointer;
      color: #00a0ff;
      text-decoration: none;
    }
  }

  .access-config {
    margin-top: $margin-large;
  }

  .log-description {
    line-height: 28px;
    margin-top: $margin-large;

    &-content {
      flex: auto;
      overflow: auto;
    }
  }

  .log-end {
    margin-top: $margin-large;

    &-title {
      text-align: center;
      font-size: 18px;

      .el-icon-circle-check-outline {
        display: inline-block;
        margin-right: 18px;
        vertical-align: middle;
        font-size: 44px;
        color: #02b212;
      }
    }

    &-content {
      display: flex;
      align-items: center;
      width: 50%;
      margin: 60px auto 30px;
      cursor: pointer;

      &-icon {
        flex: 1;
        text-align: right;

        .el-icon-document {
          font-size: 58px;
          color: #00a0ff;
        }
      }

      &-text {
        flex: 2;
        padding-left: 40px;
        line-height: 28px;
        text-align: left;

        &-title {
          font-size: 14px;
        }

        &-description {
          font-size: 12px;
          color: #999999;

          &.ellipsis {
            position: relative;
            overflow: hidden;

            &::after {
              content: '...';
              position: absolute;
              bottom: 0;
              right: 0;
              padding-left: 40px;
              background: linear-gradient(to right, transparent, #fff 55%);
            }
          }
        }
      }
    }
  }
}
</style>
